import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Box,
  Typography
} from '@mui/material';
import { getEmployees, gerarEtiquetas } from '../../services/api'; // Função para buscar empregados e gerar etiquetas
/* global BrowserPrint */

const ImpEtiquetas = ({ visible, onHide, onPrint }) => {
  // Estados locais para a impressão
  const [sacosLisos, setSacosLisos] = useState(true);
  const [referencia, setReferencia] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [numEtiquetas, setNumEtiquetas] = useState('');
  const [quantidadePorCaixa, setQuantidadePorCaixa] = useState('');
  
  // Estado para os empregados vindos da API
  const [employees, setEmployees] = useState([]);

  // Buscar empregados quando o modal é exibido
  useEffect(() => {
    if (visible) {
      getEmployees()
        .then(response => {
          console.log("Response de empregados:", response);
          setEmployees(response.data);
        })
        .catch(error => {
          console.error("Erro ao buscar empregados:", error);
          alert("Erro ao buscar empregados.");
        });
    }
  }, [visible]);

  const handleCheckboxChange = (e) => {
    setSacosLisos(e.target.checked);
    if (e.target.checked) {
      setReferencia('');
    }
  };

  const handlePrintClick = () => {
    // Valida se os campos estão preenchidos
    if (!sacosLisos && referencia.trim().length === 0) {
      alert('Por favor, insira a referência.');
      return;
    }
    if (!numEtiquetas || isNaN(numEtiquetas) || Number(numEtiquetas) <= 0) {
      alert('Por favor, insira um número válido de etiquetas.');
      return;
    }
    if (!quantidadePorCaixa || isNaN(quantidadePorCaixa) || Number(quantidadePorCaixa) <= 0) {
      alert('Por favor, insira uma quantidade válida por caixa.');
      return;
    }
    if (!selectedEmployee) {
      alert('Por favor, selecione o empregado.');
      return;
    }
    
    // Pergunta se deseja confirmar a impressão
    if (!window.confirm("Deseja confirmar a impressão das etiquetas?")) {
      return;
    }
    
    // Prepara os dados para a API
    const data = {
      // Ajuste o merchandise_id conforme necessário. Aqui usamos selectedEmployee como exemplo.
      merchandise_id: selectedEmployee,
      quantidade: Number(numEtiquetas),
      quantidade_por_caixa: Number(quantidadePorCaixa),
      saco_liso: sacosLisos,
      turno: "", // Adicione se necessário
      op: ""     // Adicione se necessário
    };

    gerarEtiquetas(data)
      .then(response => {
        const { zpl } = response.data;
        console.log("Etiqueta (ZPL) retornada do backend:", zpl);
        // Envia o ZPL para a impressora via BrowserPrint
        enviarZPLParaImpressora(zpl);
        if (onPrint) {
          onPrint(data);
        }
      })
      .catch(error => {
        console.error("Erro ao gerar etiquetas:", error);
        alert("Erro ao gerar etiquetas.");
      });
  };

  // Função para enviar o ZPL para a impressora usando BrowserPrint
  function enviarZPLParaImpressora(zplCode) {
    BrowserPrint.getDefaultDevice("printer", function(printer) {
      if (printer) {
        printer.send(zplCode, function() {
          console.log("Etiqueta enviada para a impressora com sucesso.");
        }, function(error) {
          console.error("Erro ao enviar para a impressora:", error);
          alert("Erro ao enviar para a impressora.");
        });
      } else {
        console.error("Impressora não encontrada.");
        alert("Impressora não encontrada.");
      }
    });
  }
  
  return (
    <Dialog open={visible} onClose={onHide} fullWidth maxWidth="sm">
      <DialogTitle>Imprimir Etiquetas</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          {/* Checkbox para "Sacos lisos" */}
          <FormControlLabel
            control={
              <Checkbox
                checked={sacosLisos}
                onChange={handleCheckboxChange}
              />
            }
            label="Sacos lisos"
          />
          {/* Se desmarcado, exibe o input para referência */}
          {!sacosLisos && (
            <TextField
              label="Referência"
              value={referencia}
              onChange={(e) => {
                if (e.target.value.length <= 18) {
                  setReferencia(e.target.value);
                }
              }}
              helperText={`${referencia.length}/18`}
              fullWidth
            />
          )}
          {/* Dropdown para selecionar o empregado */}
          <FormControl fullWidth>
            <InputLabel>Empregado</InputLabel>
            <Select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
              label="Empregado"
            >
              {employees.map((emp) => (
                <MenuItem key={emp.id} value={emp.id}>
                  {`${emp.name} - ${emp.numero_empregado}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Input para número de etiquetas */}
          <TextField
            label="Número de Etiquetas"
            value={numEtiquetas}
            onChange={(e) => setNumEtiquetas(e.target.value)}
            type="number"
            fullWidth
          />
          {/* Novo campo: Quantidade por Caixa */}
          <TextField
            label="Quantidade por Caixa"
            value={quantidadePorCaixa}
            onChange={(e) => setQuantidadePorCaixa(e.target.value)}
            type="number"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onHide}>Cancelar</Button>
        <Button variant="contained" onClick={handlePrintClick}>Imprimir</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImpEtiquetas;
